/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'

import {RAFFLE_POOL_TYPE} from './constants'
import type {TinyRewardItem, TreasureHuntHomepageData} from './types'

export const treasure_hunt_homepage = createAsyncThunk(
  'LuckGiftWordCup/treasure_hunt_homepage',
  async (_p: void, store: any) => {
    const resp = await http.post(
      '/live/gift/treasure_hunt_homepage',
      {
        ...store.getState().env.deviceinfo,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data as TreasureHuntHomepageData
  }
)

export const get_raffle_pool_info = createAsyncThunk(
  'LuckGiftWordCup/get_raffle_pool_info',
  async (_p: void, store: any) => {
    const resp = await http.post(
      '/live/gift/get_raffle_pool_info',
      {
        ...store.getState().env.deviceinfo,
        pool_type: RAFFLE_POOL_TYPE,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data as {rewards?: TinyRewardItem[]}
  }
)

export interface LuckGiftWordCupState {
  homepage: TreasureHuntHomepageData
  raffleRewards: TinyRewardItem[]
  loading: boolean
}

const initialState: LuckGiftWordCupState = {
  homepage: {},
  raffleRewards: [],
  loading: false,
}

export const LuckGiftWordCupSlice = createSlice({
  name: 'LuckGiftWordCup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(treasure_hunt_homepage.pending, (state) => {
        state.loading = true
      })
      .addCase(treasure_hunt_homepage.fulfilled, (state, action) => {
        state.loading = false
        state.homepage = action.payload ?? {}
      })
      .addCase(treasure_hunt_homepage.rejected, (state) => {
        state.loading = false
      })
      .addCase(get_raffle_pool_info.fulfilled, (state, action) => {
        state.raffleRewards = action.payload?.rewards ?? []
      })
  },
})

export default LuckGiftWordCupSlice.reducer

export const useLuckGiftWordCupState = (): LuckGiftWordCupState =>
  useSelector((store: any) => store.LuckGiftWordCup as LuckGiftWordCupState) ??
  initialState
